import { render, staticRenderFns } from "./LocationsGeneralView.vue?vue&type=template&id=772a9c0c"
import script from "./LocationsGeneralView.vue?vue&type=script&lang=js"
export * from "./LocationsGeneralView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports